<template>
  <div>
    <div class="bh-callout background-cover flex flex-col justify-center pt-80 items-center">
      <Card class="bh-callout-card mx-16 p-24 text-center lg:mt-24 box-shadow-sm">
        <h2 class="text-h3 md:text-h2 mb-24">You have more benefits</h2>
        <p class="text-body mb-24">
          Sittercity is one of many family care options provided by your employer. Discover all your Bright Horizons benefits.
        </p>
        <Button variant="primary" size="medium" value="view ALL BENEFITS" :href="goToMyBH" target="_blank" />
      </Card>
      <img class="sc-logo mt-60" src="@/images/bh-benefits/sc-bh-logo.svg" alt="Sittercity logo" />
    </div>
  </div>
</template>

<script lang="ts">
import Card from '@/components/card/Card.vue';
import Button from '@/components/button/Button.vue';

export default {
  name: 'BenefitsCallout',
  components: { Card, Button },
  props: {
    corpSlug: {
      type: String,
      required: true,
    },
  },
  computed: {
    goToMyBH() {
      return `https://clients.brighthorizons.com/${this.corpSlug}`;
    },
  },
};
</script>

<style lang="scss" scoped>
.bh-callout {
  background-image: url('@/images/bh-benefits/Hills.svg');
}
.background-cover {
  background-size: 100% 100%;
  min-height: 529px;
}
.bh-callout-card {
  max-width: 510px;
}
</style>
